import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminMenu from "./AdminMenu";
import styled from "styled-components";
import toast ,{ Toaster } from "react-hot-toast";
import { Button } from "../styles/Button";
import PageHeader from "../components/PageCloseButton";
import { toTitleCase, normalize, normalizeNoSpaces } from "../Helpers/stringTitlecase.js";



const CreateCategory=()=>{
      const [data, setData] = useState({
        value:"",
        label:""
      })

    const [categories, setCategories] = useState([]);
    const navigate=useNavigate();

        const handleChange = (e) => {
        const { id, value } = e.target;
          setData((prev) => ({
          ...prev,
          [id]: toTitleCase(value),
          }));
        };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        // const res = await fetch("http://localhost:8080/api/products/categories");
        const res = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/products/categories`);
        const result = await res.json();
        setCategories(result);
      } catch (error) {
        toast.error("Failed to load categories");
      }
    };
    fetchCategories();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

  const duplicate = categories.find(
     (cat) =>      
    normalize(cat.value) === normalize(data.value) ||
    normalize(cat.label) === normalize(data.label) ||
    normalizeNoSpaces(cat.value) === normalizeNoSpaces(data.value) ||
    normalizeNoSpaces(cat.label) === normalizeNoSpaces(data.label)
    );


  if (duplicate) {
    toast.error("Category already exists!");
    return; 
    }

try{

    // const response = await fetch('http://localhost:8080/api/products/categories', {
    const response = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/products/categories`, {
      method: 'POST',
      headers: {
      'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  
  if (!response.ok) {
      toast.error('categorycannot be added')
      throw new Error('category creation failed');
      }
    
  const result = await response.json();
    toast.success('Category added successfully');
    navigate('/subcategory')
    // console.log('Product added:', result);
    } 

  catch(error) {
    // console.error('form', error);
    toast.error('Category failed')
    }
    };
  
    
return(
            
  <Wrapper>
     <Toaster position='top-center' reverseOrder={false}></Toaster>
     <div className="grid grid-two-column">
       <AdminMenu/>
       <div className="main-container">
          <div className="category">
            <PageHeader title="Create Category" /> 
            <form onSubmit={handleSubmit} autoComplete="off">
                <div className="product-container">
                  <label htmlFor="value">Category Value</label>
                    <input id="value" 
                    value={data.value}
                    onChange={handleChange} 
                    placeholder="value" 
                  />
                    
                  <label htmlFor="label">Category Label</label>
                  <input id="label" 
                  value={data.label}
                  onChange={handleChange} 
                  placeholder="label" 
                  />
              </div>
                <div className="product-container">
                <Button type="submit">Add</Button>
              </div>
            </form>
          </div>
       </div>
      </div>  
  </Wrapper>
  )
}

const Wrapper=styled.section`

   
.grid-two-column {
  grid-template-columns: 2fr 8fr;
 }
.main-container {
  justify-content: centre;
  align-items: center;
  padding : 3rem;
  }


.category{
  display: flex;
  flex-direction: column;
  width: 40%;
  margin-top: 2rem;
  padding: 3rem;
  border-radius: 0.8rem;
  background-color:${({ theme }) => theme.colors.bg};
  box-shadow: 0 2px 10px rgba(0,0,0,0.3) 
  
  }

  .product-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 1rem;
    padding: 3rem;
    gap: 1rem;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    }


@media (max-width: ${({ theme }) => theme.media.mobile}){
 
.grid-two-column {
  grid-template-columns: 1fr; /* stack columns */
  }

.container {
  margin: 0rem;
   }
  
  .category {
    width: 1000%;
    max-width: 97%;
    margin-top: 1rem;
    padding: 1rem;
    }

  .product-container {
    Padding: 2rem;   
    gap: 0.5rem;
    padding: 1rem;
   }  
 
 
}`;

export default CreateCategory